<template>
  <b-card id="globalSettings" class="p-sm-4 m-sm-4 my-4">
    <h5 v-if="circledNum" class="circled-number">{{ circledNum }}</h5>
    <h5 class="card-title pt-2">Global Settings</h5>

    <b-row>
      <b-col lg="6">
        <b-form-group>
          <cool-label>
            Bidfloor
            <span
              v-b-popover.hover.click.right="'Select the minimum price that advertisers can pay to place their ad in your zone.'"><span
              class="icon icon-Tooltip h5 d-inline align-text-bottom"></span></span>
          </cool-label>
          <b-input-group prepend="$">
            <b-form-input
              type="number"
              v-model="zone.bidfloor"
              placeholder="0.00">
            </b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col sm="6" md="4" lg="3">
        <b-form-group>
          <cool-label>
            Timeout Rate
            <span
              v-b-popover.hover.click.right="'How long should requests be active before they are considered timed out?'"><span
              class="icon icon-Tooltip h5 d-inline align-text-bottom"></span></span>
          </cool-label>
          <b-form-select
            :options="timeoutRateOptions"
            v-model="zone.tmax"/>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="zone.integration === 'RTB'">
      <b-col>
        <b-form-group
          label="External App/Site ID"
          description="The tag id in the bid request sent to us,
                  used to recognize this unique placement by mapping your id to ours. Not required but suggested to enable
                  demand partner targeting and matching report field names">
          <b-alert variant="warning" :show="!medium.external_id">
            You must first setup external ID mapping for this App or Site before you can map
            individual placements.
          </b-alert>
          <b-form-input v-model="zone.external_id" :disabled="!medium.external_id"/>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="zone.integration === 'VAST'">
      <b-col>
        <b-form-group
          label="Fixed Price"
          description="Zone impressions always cost bid floor pricing">
          <toggle-button
            v-model="zone.fixed_price"
            :sync="true"
            color="var(--primary)">
          </toggle-button>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col v-if="zone.integration === 'JSTAG'"
             sm="6" md="4" lg="3">
        <b-form-group>
          <cool-label>
            Do you have a backup tag?
            <span
              v-b-popover.hover.click.right="'If there is HTML code that should be placed in the space if no ad wins the auction, define it here.'"><span
              class="icon icon-Tooltip h5 d-inline align-text-bottom"></span></span>
            <div>(html only)</div>
          </cool-label>
          <b-form-radio-group
            v-model="backupTag">
            <b-form-radio :value="true">Yes</b-form-radio>
            <b-form-radio :value="false">No</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-collapse id="backupTagCollapse" :visible="backupTag">
      <b-row>
        <b-col lg="3" md="4" sm="6">
          <b-form-group>
            <cool-label>
              Backup Tag Width (px)
            </cool-label>
            <b-input type="number"
                     v-model="zone.backup_tag.w">
            </b-input>
          </b-form-group>
        </b-col>
        <b-col lg="3" md="4" sm="6">
          <b-form-group>
            <cool-label>
              Backup Tag Height (px)
            </cool-label>
            <b-input type="number"
                     v-model="zone.backup_tag.h">
            </b-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group>
        <label class="text-muted text-uppercase font-weight-bold small">
          Backup Tag
        </label>
        <b-form-textarea
          v-model="zone.backup_tag.adm"
          class="rounded"
          placeholder="Backup tag source goes here"
          :rows="3">
        </b-form-textarea>
      </b-form-group>
    </b-collapse>
  </b-card>
</template>

<script type="text/javascript">
  import {PublisherApi} from "../../../api"

  export default {
        props: {
            circledNum: {required: false, type: String},
            value: {required: true, type: Object}
        },
        created() {
          PublisherApi.mediumDetails(this.value.company_id, this.value.med_id).then((med) => this.medium = med)
        },
        data() {
            return {
                medium: {},
                backupTag: false,
                timeoutRateOptions: [
                    {value: 100, text: '100MS'},
                    {value: 200, text: '200MS'},
                    {value: 300, text: '300MS'},
                    {value: 400, text: '400MS'},
                    {value: 500, text: '500MS'}
                ]
            }
        },
        computed: {
            zone() {
                return this.value
            }
        },
        watch: {
            backupTagInfo() {
                if (this.backupTagInfo.length !== 0) {
                    this.backupTag = true
                }
            },
            backupTag() {
                if (!this.backupTag) {
                    this.$emit('update:backupTagInfo', '')
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/publisher/pages/Zone/ZoneSettings/GlobalSettings.vue